import { useStore } from 'react-redux';

import { CFD_EVENTS, HUB_EVENTS } from '~/main/namespace';
import { LoggerScope } from '~/main/utils/logger';
import Logger from '~/renderer/utils/logger';
import { HUB_MESSAGES } from '~/types/socket';

import { useEventListener } from '../use-event-listener';
import { socketActionCreator } from './actions';
import { CFD_MESSAGES, PRINTER_MESSAGES, Publish } from './types';

export const useLocalServer = (): Publish => {
  const publish: Publish = (event, data) => {
    window.ipcRenderer.send(HUB_EVENTS.LOCAL_SERVER_PUBLISH, event, data);
  };
  const store = useStore();
  const actions = socketActionCreator(publish, store, LoggerScope.LOCAL_SERVER);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionsMap: { [eventName: string]: (data?: any) => void } = {
    [CFD_MESSAGES.SALE_UPDATED]: actions.onSaleUpdated,
    [CFD_MESSAGES.TIP_FLOW_START]: actions.onStartTipFlow,
    [CFD_MESSAGES.SALE_COMPLETED]: actions.onSaleCompleted,
    [CFD_MESSAGES.HIDE_SALE]: actions.onHideSale,
    [CFD_MESSAGES.SHOW_SALE]: actions.onShowSale,
    [CFD_MESSAGES.CUSTOMER_START]: actions.onCustomerStart,
    [CFD_EVENTS.CREATE_CFD]: actions.onNewCFD,
    [CFD_MESSAGES.CLOSE]: actions.onCFDClose,
    [HUB_MESSAGES.CONFIG_UPDATED]: actions.onConfigUpdated,
    [CFD_MESSAGES.COMPLETE_PAYMENT]: actions.onTerminalPaymentApproved,
    [PRINTER_MESSAGES.PRINT]: actions.onPrint,
    [PRINTER_MESSAGES.OPEN_CASH_DRAWER]: actions.onOpenCashDrawer,
    [HUB_MESSAGES.UPDATE_CHANNEL_NAME]: actions.updateChannelName,
  };

  useEventListener(HUB_EVENTS.LOCAL_SERVER_CONNECTION_CHANGED, (_, connected) => {
    if (connected) {
      actions.setLocalServerConnected();
      actions.onConnectedToRetail(true);
    } else {
      actions.setLocalServerDisconnected();
    }
  });

  useEventListener(HUB_EVENTS.LOCAL_SERVER_RECEIVE, (_, eventName, data) => {
    const eventHandler = actionsMap[eventName];
    if (eventHandler) {
      eventHandler(data);
    } else {
      Logger({ scope: LoggerScope.LOCAL_SERVER }).error({
        msg: 'missing action for',
        eventName,
        err: new Error('missing action'),
      });
    }
  });

  return publish;
};
